import { Component, Inject, OnInit } from '@angular/core';
import { WarningDialogue } from '../warning-dialogue/warning.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-location-confirm-dialog',
  templateUrl: './location-confirm-dialog.component.html',
  styleUrls: ['./location-confirm-dialog.component.scss'],
})
export class LocationConfirmDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public confirmData: WarningDialogue,
    public dialogRef: MatDialogRef<any>
  ) {}

  ngOnInit() {}

  get hasImage() {
    return this.confirmData.image === '' ? false : true;
  }

  submit() {
    this.dialogRef.close(true);
  }

  oncancel() {
    this.dialogRef.close();
  }
}
